import { TrialPeriodDateInput } from '../TrialPeriodDateInput';
import { UPDATE_NETWORK_PROTECTION_SETTINGS } from '@/common/actions/update';
import { useMutation } from '@apollo/client';
import { Box, RadioButtonsGroup, Switch, Typography } from '@servicepipe/ui-components';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const visibilityOptions = [
  { value: 'INVISIBLE', label: 'INVISIBLE' },
  { value: 'DEMO', label: 'DEMO' },
  { value: 'VISIBLE', label: 'VISIBLE' },
];

const toTrialDate = (value) => {
  if (!value) {
    return new Date();
  }

  return value instanceof Date ? value : new Date(value);
};

export const Header = ({ data }) => {
  const [trialPeriod, setTrialPeriod] = useState(toTrialDate(data.trialPeriod));
  const [switchTrialPeriod, setSwitchTrialPeriod] = useState(Boolean(data.trialPeriod));
  const [visibility, setVisibility] = useState(data.visibility);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [updateNetworkProtectionSettingsApi] = useMutation(UPDATE_NETWORK_PROTECTION_SETTINGS, {
    onCompleted: () => toast.success('Success'),
    onError: (err) => toast.error(err.message),
  });

  const updateNetworkProtectionSettingsApiHandle = () => {
    updateNetworkProtectionSettingsApi({
      variables: {
        id: data.id,
        visibility,
        trialPeriod: switchTrialPeriod ? trialPeriod : null,
      },
    });
  };

  const handleTrialSwitchChange = (value) => {
    setSwitchTrialPeriod(value);
    if (!value) {
      setTrialPeriod(new Date());
    }
  };

  const handleVisibilityChange = (value) => {
    setVisibility(value);
  };

  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false);
      return;
    }
    updateNetworkProtectionSettingsApiHandle();
  }, [switchTrialPeriod, trialPeriod, visibility]);

  return (
    <Box display="flex" direction="row" width="100%" gap="24px" wrap="wrap">
      <Box width="60%" minWidth="280px" direction="column" gap="24px" flexGrow={1}>
        <Box display="flex" direction="column" gap="8px">
          <Typography variant="h6">Service visibility in client dashboard:</Typography>

          <RadioButtonsGroup
            name="networkProtectionVisibility"
            direction="row"
            selectedValue={visibility ?? undefined}
            options={visibilityOptions}
            onChange={handleVisibilityChange}
          />
        </Box>

        <Box gap="18px" align="center" direction="row" wrap="wrap">
          <Box width="160px">
            <Switch
              label="Trial period till:"
              checked={switchTrialPeriod}
              onChange={handleTrialSwitchChange}
            />
          </Box>

          <Box width="140px" flexShrink={0}>
            <TrialPeriodDateInput
              disabled={!switchTrialPeriod}
              value={trialPeriod}
              onChange={setTrialPeriod}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
